import React, { useEffect, useState } from 'react';
import { CardElement } from "@stripe/react-stripe-js";
import { Form } from "react-bootstrap";
import styles from "./CardFieldForm.module.scss";

const CARD_OPTIONS = {
  style: {
    base: {
      iconColor: '#c4f0ff',
      color: '#000',
      fontWeight: 'solid',
      fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      ':-webkit-autofill': {
        color: '#fce883',
      },
      '::placeholder': {
        color: '#87bbfd',
      },
      padding: '12px',
      lineHeight: '2.5em'
    },
    invalid: {
      iconColor: '#ffc7ee',
      color: '#ffc7ee',
    },
  },
  hidePostalCode: true
};

const ErrorMessage = ({children}) => (
  <div className={styles.ErrorMessage} role="alert">
    <svg width="16" height="16" viewBox="0 0 17 17">
      <path
        fill="#FFF"
        d="M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z" />
      <path
        fill="#6772e5"
        d="M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z" />
    </svg>
    {children}
  </div>
);

interface ICardField {
  onError: (error: any) => void;
  error?: { message: string };
  onCardChange?: () => void;
  onCompleteChange?: (bool: boolean) => void;
};

const CardFieldForm = (props: ICardField) => {
  const [error, setError] = useState(null);

  const handleOnChange = e => {
    setError(e.error);
    props.onError(e.error);

    // Notify parent component when card info changes
    if (props.onCardChange) {
      props.onCardChange();
    }
    if (props.onCompleteChange) {
      props.onCompleteChange(e.complete)
    }
  };

  useEffect(() => {
    if (!props.error) return;
    setError(props.error);
  }, [props.error]);

  return(
    <fieldset>
      <div className="form-group">
        <Form.Label>Card No</Form.Label>
        <div className={styles.FormControl}>
          <CardElement options={CARD_OPTIONS} onChange={handleOnChange} />
        </div>
        {error && <ErrorMessage>{error.message}</ErrorMessage>}
      </div>
    </fieldset>
  );
};

export default CardFieldForm;
